import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Route, Routes } from "react-router-dom";
import GameCriteria from "../pages/gameCriteria";
import GameList from "../pages/gameList";
import VideoList from "../pages/videoList";
import SideBar from "./common/SideBar";
import ContentLayout from "./common/ContentLayout";
import $ from "jquery";

import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import { authActions } from "./store";

import jwtDecode from "jwt-decode";

export default function ClipWrapperLayout(content, { match, props }) {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const today = new Date();
    const currentYear = today.getFullYear();

    const initCriteria = {
        seasons: [currentYear],
        month: "",
        gameTypes: ["4201"],
        position: "batter",
        teamId: 4001,
        oppTeamId: 0,
        batterIds: [],
        pitcherIds: [],
        playerIds: [],
        oppPlayerIds: [],
        latestGames: false,
        checkbase: false,
        gameInfoIds: [],
        innings: [],
        ballCodes: [],
        runnerStatus: [],
        ballCounts: [],
        hitTypes: [],
        hitResults: [],
        battedBallTypeCodes: [],
        checkbases: [],
        battedBallRanks: [],
        pitcherTypes: [],
        batterTypes: [],
        minBallSpeed: "",
        maxBallSpeed: ""
    };

    const detailCriteria = [
        "innings",
        "checkbases",
        "ballCodes",
        "ballCounts",
        "runnerStatus",
        "hitTypes",
        "hitResults",
        "battedBallTypeCodes",
        "battedBallRanks",
        "pitcherTypes",
        "batterTypes",
        "minBallSpeed",
        "maxBallSpeed"
    ];

    const [menuTitle, setMenuTitle] = useState("메뉴 타이틀");
    const [gameCriteria, setGameCriteria] = useState();
    const [isToggled, setIsToggled] = useState("");

    useEffect(() => {
        let storedCriteria = localStorage.getItem("gameCriteria");
        let criteria = null;
        let settingParam = JSON.parse(storedCriteria);;
        if (storedCriteria !== "undefined" && storedCriteria !== null) {
            if(settingParam.gameTypes == undefined){
                delete settingParam.gameType;
                settingParam.gameTypes = ["4201"];
            }
            if(settingParam.seasons == undefined) {
                delete settingParam.season;
                settingParam.seasons = [currentYear];
            }
            
            criteria = settingParam;
        } else {
            criteria = initCriteria;
        }

        localStorage.setItem("gameCriteria", JSON.stringify(criteria));
        setGameCriteria(criteria);

        checkDeviceHandler();
    }, []);

    useEffect(() => {
        // 경로가 '/gameCriteria'로 끝나는 경우에만 실행
        if (location.pathname.endsWith("/gameCriteria")) {
            setGameCriteria((prevCriteria) => {
                // prevCriteria가 아직 설정되지 않았다면(첫 로딩 시) 아무것도 하지 않음
                if (!prevCriteria) return prevCriteria;

                // 기존 prevCriteria를 복사하여 기본 조건은 유지
                const newCriteria = { ...prevCriteria };

                // detailCriteria 배열에 정의된 키(key)들을 순회하며
                // initCriteria에 있는 기본값으로 덮어씁니다.
                detailCriteria.forEach((key) => {
                    newCriteria[key] = initCriteria[key];
                });

                // 상세 조건만 초기화된 새로운 criteria 객체를 반환
                return newCriteria;
            });
        }
    }, [location.pathname]);

    useEffect(() => {
        //accessToken 유효시간 만료 여부 확인
        let accessToken = localStorage.getItem("accessToken");

        if (accessToken) {
            checkExpTime();
        }
    }, []);

    let movingHandler = (link) => {
        var ExpYn = checkExpTime();

        if (!ExpYn) {
            navigate(link, { replace: true });
        }
    };

    const checkDeviceHandler = () => {
        //모바일에서 볼 경우 사이드 메뉴를 접어주는 역할
        if (isMobile) {
            setIsToggled("toggled");
        }
    };

    const resetHandler = () => {
        let init = { ...initCriteria };
        setGameCriteria(init);

        detailCriteria.forEach(function (item) {
            $("[name='" + item + "']").css("backgroundColor", "");
            $("[name='" + item + "']").removeClass("active");
        });
    };

    const sidebarHandler = (evt) => {
        if (isToggled === "") setIsToggled("toggled");
        else setIsToggled("");
    };

    const checkExpTime = () => {
        // console.log("checkExpTime 함수 실행");
        //로그인 시간 만료되었는지 확인
        let currentTime = new Date().getTime() / 1000;
        let accessToken = localStorage.getItem("accessToken");

        const decoded = jwtDecode(accessToken);

        if (decoded.exp < currentTime) {
            dispatch(authActions.logout());
        } else {
            return false;
        }
    };

    return gameCriteria ? (
        <>
            <SideBar
                movingHandler={movingHandler}
                criteria={gameCriteria}
                currentLocation={location}
                isToggled={isToggled}
                useLang={content.useLang}
            />
            <ContentLayout
                sidebarHandler={sidebarHandler}
                menuTitle={menuTitle}
                useLang={content.useLang}
                setUseLang={content.setUseLang}
                isToggled={isToggled}
            >
                <Routes>
                    <Route
                        path="gameCriteria"
                        element={
                            <GameCriteria
                                movingHandler={movingHandler}
                                criteria={gameCriteria}
                                setCriteria={setGameCriteria}
                                resetHandler={resetHandler}
                                setMenuTitle={setMenuTitle}
                                detailCriteria={detailCriteria}
                                useLang={content.useLang}
                                isMobile={isMobile}
                            />
                        }
                    ></Route>
                    <Route
                        path="gameList"
                        element={
                            <GameList
                                movingHandler={movingHandler}
                                criteria={gameCriteria}
                                setCriteria={setGameCriteria}
                                setMenuTitle={setMenuTitle}
                                useLang={content.useLang}
                            />
                        }
                    ></Route>
                    <Route
                        path="videoList"
                        element={
                            <VideoList
                                movingHandler={movingHandler}
                                criteria={gameCriteria}
                                setCriteria={setGameCriteria}
                                setMenuTitle={setMenuTitle}
                                useLang={content.useLang}
                                isMobile={isMobile}
                            />
                        }
                    ></Route>
                </Routes>
            </ContentLayout>
        </>
    ) : (
        <></>
    );
}
